import axios from "@/axios";

export const namespaced = true;

const defaultData = {
    orderId: 0,
    purchaseNumber: null,
    invoiceNumber: null,
}

export const state = {
    financeInfo: Object.assign({}, defaultData),
    status: false,
    financeInfoErrors: []
};

export const getters = {
    financeInfo: state => {
        return state.financeInfo;
    },
    financeInformationStatus: state => {
        return state.status
    },
    financeInfoErrors: state => state.financeInfoErrors
};

export const mutations = {
    SET_FINANCE_INFO(state, response) {
        state.financeInfo = Object.assign({}, defaultData, response.data)
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.financeInfo = Object.assign({}, defaultData)
    },
    SET_ERRORS(state, data) {
        state.financeInfoErrors = data;
      },
      CLEAR_ERRORS(state) {
          state.financeInfoErrors = [];
      }
};

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getFinanceInformationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false);
        } else {
            return await axios.get('/api/financeinformation/status/' + id)
                .then(({ data }) => {
                    commit("SET_STATUS", data);
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                      commit("SET_STATUS", false);
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },
    async loadFinanceInformation({ commit }, orderId) {
        try {
            commit("SET_FINANCE_INFO", await axios.get(`/api/financeinformation/${orderId}`));
        }
        catch (error) {
            console.log("ERROR LOADING FINANCE INFORMATION: ", error); //not handelled
        }
    },
    async saveFinanceInfoToServer({ commit, state, dispatch }, orderId) {
        return new Promise((resolve, reject) => {
            state.financeInfo.orderId = orderId
            axios.post("/api/financeinformation", state.financeInfo)
                .then((response) => {
                    return resolve();
                })
                .catch(function (error) {
                    return reject("There was an error saving the Finance Information to the server.");
                })
        });
    }
};